import { api } from '@here/api'
import { untrack } from 'solid-js'
import { createSignal } from 'solid-js'

export function useImage() {
	const [imageDictionary, setImageDictionary] = createSignal<Record<string, string>>({})

	const loadImage = untrack(() => async (src?: string) => {
		if (src === undefined) {
			return
		}

		const isLoading = imageDictionary()[src]

		if (isLoading) {
			return
		}

		setImageDictionary({
			...imageDictionary(),
			[src]: 'loading',
		})

		const { data, error } = await api()
			.storage.from('setup-images')
			.createSignedUrl(src, 60 * 60)

		setImageDictionary({
			...imageDictionary(),
			[src]: error ? 'error' : data.signedUrl,
		})
	})

	const getImage = (src?: string) => {
		if (!src) {
			return ''
		}

		const imageSrc = imageDictionary()[src]

		if (imageSrc === undefined) {
			loadImage(src)
		}

		return imageSrc
	}

	return {
		imageDictionary,
		loadImage,
		getImage,
	}
}
